/*
 * PaginatorConstants
 */

export const SET_PAGE_NUMBER = 'ideal/Paginator/SET_PAGE_NUMBER';
export const GET_PAGE_NUMBER = 'ideal/Paginator/GET_PAGE_NUMBER';

export const SET_ITEMS_PER_PAGE = 'ideal/Paginator/SET_ITEMS_PER_PAGE';
export const GET_ITEMS_PER_PAGE = 'ideal/Paginator/GET_ITEMS_PER_PAGE';

export const GET_PAGINATOR = 'ideal/Paginator/GET_PAGINATOR';
export const UPDATE_PAGINATOR = 'ideal/Paginator/UPDATE_PAGINATOR';
